// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9d22afd3","133":"865b77d6","190":"4b87f63b","511":"51b97ff5"}[chunkId] + ".chunk.js";
};